import React from 'react';
import haWrapper from '../../utils/haWrapper';
import {sendCustomAnalytics} from '../../utils/loadTimeAnalyticsWrapper';

class Timing extends React.Component {
    constructor(props) {
        super(props);
        const {measureName} = props;
        haWrapper.userTiming.mark(`${measureName}_start`);
    }

    componentDidMount() {
        const {measureName, tags} = this.props;
        haWrapper.userTiming.mark(`${measureName}_end`);
        haWrapper.userTiming.measureAndSend(
            measureName,
            `${measureName}_start`,
            `${measureName}_end`
        );
        sendCustomAnalytics(measureName, 'measure', (analytics) => ({
            [`${measureName}DurationTime`]: {value: analytics.duration, tags},
            [`${measureName}StartTime`]: {value: analytics.startTime, tags}
        }));
    }

    componentWillUnmount() {
        const {measureName} = this.props;
        haWrapper.userTiming.clearMarks(`${measureName}_start`);
        haWrapper.userTiming.clearMarks(`${measureName}_end`);
        haWrapper.userTiming.clearMeasures(measureName);
    }

    render() {
        return this.props.children;
    }
}

export default Timing;
